import axios from "axios";
import { Auth } from "./authService";
const { BACKEND_URL } = require("../config/config");

const authController = new Auth();

export async function obtenerAccesosPorUsuario(id) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/accesosPorUsuario/${id}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

export async function obtenerAccesosPorUsuarioExpediente(id, id_expediente) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/accesosPorUsuarioExpediente/${id}?expediente=${id_expediente}`;

  return axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });
}

export async function guardarAccesosPorUsuario(id_usuario, accesos) {
  const token = authController.getAccessToken();
  const url = `${BACKEND_URL}/accesosPorUsuario/${id_usuario}`;
  return axios.put(
    url,
    accesos, // Los datos actualizados del expediente
    {
      headers: {
        Authorization: `Bearer ${token}`, // Asegúrate de incluir el token de autorización si es necesario
        "Content-Type": "application/json", // Asegúrate de que el tipo de contenido esté configurado correctamente
      },
    }
  );
}


